export default __webpack_public_path__ + "static/media/Clothing supply chain.4a1e86f9.svg";